export enum PAGE_ACTIONS {
  ADD_TO_COLLECTIONS = 'ADD_TO_COLLECTIONS',
  CREATE_COLLECTION = 'CREATE_COLLECTION',
  ADD_TO_BASKET = 'ADD_TO_BASKET',
  MOVE_TO_TRASH = 'MOVE_TO_TRASH',
  ADD_TO_SHARE = 'ADD_TO_SHARE',
  GET_CAMPAIGN_LINKS = 'GET_CAMPAIGN_LINKS',
  CUTOUT_BACKGROUND = 'CUTOUT_BACKGROUND',
  REPROCESS = 'REPROCESS',
}

// Mirrors MAX_BULK_CUTOUT_IDS in filespin/api/bg_remove.py. Kept as a local
// constant so the action disables itself rather than letting the request 400.
export const MAX_BULK_CUTOUT_ASSETS = 100;

export const ITEMS_PER_PAGE_LOCAL_KEY = 'fs.assets.itemsPerPage';

// Post-upload placeholder handling: the backend indexes uploads
// asynchronously, so freshly uploaded assets are shown as pending
// placeholders while the search query polls until they appear (or expire).
export const PENDING_UPLOAD_POLL_INTERVAL_MS = 5000;
export const PENDING_UPLOAD_TIMEOUT_MS = 60000;

export const INITIAL_FILTERS = {
  page: 1,
  hash: '',
  face: null,
  limit_per_page: 30,
  keyword: '',
  extended_result: true,
  sort_by: ['upload_time_range_DESC'],
  content_type: '',
  file_name: '',
  trashed: false,
  upload_time_range: {
    start: undefined,
    end: undefined,
  },
  status: '',
  custom_content_input:'',
  // schema_criteria:{
  //   data_schema_id:undefined
  // }
  filters:null,
  addons_criteria: []
};
